import { bool, number, object, string } from "yup";
import { PBNSchema } from "./PBN";

export const urlsMetricsSchema = object({
    pbn: PBNSchema,
    traffic: number(),
    kd: number(),
    keyword: string(),
    comment: string().notRequired(),
    position: number(),
    volume: number(),
    id: number(),
    name: string(),
    active: bool(),
});
